export default __webpack_public_path__ + "static/media/Catalogue-amico.d3e70f05.svg";